/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientLegalEntityBillingInformationAddressUpdateRequest
 */
export interface ClientLegalEntityBillingInformationAddressUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationAddressUpdateRequest
     */
    formattedAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationAddressUpdateRequest
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationAddressUpdateRequest
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationAddressUpdateRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationAddressUpdateRequest
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationAddressUpdateRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationAddressUpdateRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationAddressUpdateRequest
     */
    region?: string;
}

/**
 * Check if a given object implements the ClientLegalEntityBillingInformationAddressUpdateRequest interface.
 */
export function instanceOfClientLegalEntityBillingInformationAddressUpdateRequest(value: object): value is ClientLegalEntityBillingInformationAddressUpdateRequest {
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function ClientLegalEntityBillingInformationAddressUpdateRequestFromJSON(json: any): ClientLegalEntityBillingInformationAddressUpdateRequest {
    return ClientLegalEntityBillingInformationAddressUpdateRequestFromJSONTyped(json, false);
}

export function ClientLegalEntityBillingInformationAddressUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientLegalEntityBillingInformationAddressUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'street': json['street'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'city': json['city'],
        'zipCode': json['zipCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'countryCode': json['countryCode'],
        'region': json['region'] == null ? undefined : json['region'],
    };
}

export function ClientLegalEntityBillingInformationAddressUpdateRequestToJSON(value?: ClientLegalEntityBillingInformationAddressUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'formattedAddress': value['formattedAddress'],
        'street': value['street'],
        'street2': value['street2'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'country': value['country'],
        'countryCode': value['countryCode'],
        'region': value['region'],
    };
}

